<template>
        <div class="pro">
            <div class="img">
                <img :src="project.projectImg" alt="">
            </div>
            <div class="con">
                <div class="content"><span>园区地址：</span><span>{{project.projectAddress}}</span></div>
                <div class="content"><span>占地面积：</span><span>{{project.projectArea}} m<sup>2</sup></span></div>
                <div class="content"><span>受电容量：</span><span>{{message["受电容量"]}}kVA</span></div>
                <div class="content"><span>电压等级：</span><span>{{message["供电电压"]}}KV</span></div>
                <div class="content"><span>供电来源：</span><span>{{message["供电来源: "]}}KV</span></div>
                <div class="content"><span>地理位置：</span><span>{{message["地理位置: "]}}</span></div>
                <div class="content"><span>供电公司：</span><span>{{message["管辖单位: "]}}</span></div>
            </div>
        </div>
    
</template>

<script>
import { GetBaseInfo } from '../../components/Request'
export default {
    data(){
        return {
            project:{},
            message:{}
        }
    },
    mounted(){
        this.getBaseInfo()
    },
    methods:{
        async getBaseInfo(){
            let res = await GetBaseInfo({projectId:this.$store.state.projectId})
            this.project = res.data.data.project
            this.message = JSON.parse(res.data.data.project.projectDetailsInfo)
            // console.log(this.project );
            // console.log(this.message );

        }
    },
}
</script>

<style lang="less" scoped>
    .pro{
        width: 100%;
        background: linear-gradient(90deg, #030D18 0%, #162C5D 100%);
        padding: 16rem;
        .img{
            width: 100%;
            height: 19.16vh;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .con{
            width: 100%;
            height: 28vh;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            .content{
                color: #E6F3FD;
                font-family: MicrosoftYaHei;
                font-size: 16rem;
                display: flex;
                flex-direction: row;
                span:nth-child(1){
                    white-space: nowrap;
                }
            }
            .content:nth-child(2){
                span:nth-child(2){
                    margin-top: -0.4vh;
                }
            }
        }
    }
</style>